export default "__VITE_ASSET__BxPtSY17__"